import {
    DICTIONARY_LOADING,
    DICTIONARY_LOADED,
    DICTIONARY_LOADED_ERROR,
    SHARE_DATE_SEND,
    SHARE_DATE_ACKNOWLEDGE,
    SHARE_DATA_ERROR,
    PERMISSIONS_REQUEST,
    PERMISSIONS_RECEIVED,
    PERMISSIONS_RECEIVED_ERROR,
    PERMISSIONS_REVOKE,
    PERMISSIONS_REVOKE_OK,
    PERMISSIONS_REVOKE_ERROR
} from "../action/shareDataActions"

const initialState = {
    permissionsLoaded: false,
    permissionsList: [],
    dictionaryLoaded: false,
    purposesList: [],
    phonesList: [],
    dataSend: false,
    acknowledgeOk: null,
    acknowledgeMessage: "",
    revokeRequestSended: false,
    revokeError: false,
}

export const shareDataReducer = function (state = initialState, action) {
    switch (action.type) {
        case PERMISSIONS_REQUEST: {
            return {
                ...state,
                permissionsLoaded: false
            }
        }

        case PERMISSIONS_RECEIVED: {
            const permissionsListReceived = action.permissionsListReceived
            return {
                ...state,
                permissionsLoaded: true,
                permissionsList: permissionsListReceived
            }
        }

        case PERMISSIONS_RECEIVED_ERROR: {
            return {
                ...state,
                permissionsLoaded: false
            }
        }

        case DICTIONARY_LOADING: {
            return {
                ...state
            }
        }

        case DICTIONARY_LOADED: {
            const purposes = action.dictionaries.purposes.map(p => ({
                ...p,
            }))
            const phones = action.dictionaries.phones.map(p => ({
                ...p,
            }))
            return {
                ...state,
                purposesList: purposes,
                phonesList: phones,
                dictionaryLoaded: true
            }
        }

        case DICTIONARY_LOADED_ERROR: {
            return {
                ...state
            }
        }

        case SHARE_DATE_SEND: {
            return {
                ...state,
                dataSend: true,
                acknowledgeOk: null,
                acknowledgeMessage: ""
            }
        }

        case SHARE_DATE_ACKNOWLEDGE: {
            const ack = action.acknowledge
            const currentPermission = ack.permission
            return {
                ...state,
                dataSend: false,
                acknowledgeOk: ack.ok,
                acknowledgeMessage: ack.message,
                permissionsList: [currentPermission].concat(state.permissionsList)
            }
        }

        case SHARE_DATA_ERROR: {
            return {
                ...state,
                dataSend: false,
                acknowledgeOk: false,
                acknowledgeMessage: "Error"
            }
        }

        case PERMISSIONS_REVOKE: {
            return {
                ...state,
                revokeRequestSended: true,
                revokeError: false,
            }
        }

        case PERMISSIONS_REVOKE_OK: {
            const shareDataId = action.shareDataId
            const expirationDate = action.newExpirationDate
            const newStatus = action.newStatus
            const permissionsList = state.permissionsList.slice()
            permissionsList.filter(p => p.id === shareDataId)
                .forEach(p => {
                    p.expirationDate = expirationDate
                    p.status = newStatus
                    p.active = false
                })
            return {
                ...state,
                permissionsList: permissionsList,
                revokeRequestSended: false,
            }
        }

        case PERMISSIONS_REVOKE_ERROR: {
            return {
                ...state,
                revokeRequestSended: false,
                revokeError: true,
            }
        }

        default:
            return state
    }
}